"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getDomSelection_1 = __importDefault(require("../selection/getDomSelection"));

var change_1 = require("../change");

var inputEventSupported = new InputEvent('insertText').getTargetRanges != null;
var actionKeys = ['Backspace', 'Delete', 'Meta', 'Alt', 'Enter', 'Control', 'Shift', 'Tab', 'Escape', 'CapsLock'];

var isCharacterInsert = function isCharacterInsert(e) {
  return e.key !== 'Unidentified' && !e.altKey && !e.metaKey && !e.ctrlKey && !e.key.includes('Arrow') && !actionKeys.includes(e.key);
};

var isMoveFocus = function isMoveFocus(e) {
  return e.shiftKey && ['ArrowLeft', 'ArrowRight'].includes(e.key);
};

var isSelectAll = function isSelectAll(e) {
  return e.metaKey && e.key.toLowerCase() === 'a';
};

var isUndo = function isUndo(e) {
  return !e.shiftKey && e.metaKey && e.key === 'z';
};

var isRedo = function isRedo(e) {
  return e.shiftKey && e.metaKey && e.key === 'z';
};

function handleKeyDown(editorState, event) {
  var newEditorState;
  var position = getDomSelection_1.default(editorState.list);

  if (position === null) {
    console.warn('cant get start and end selection, resume with current state');
    position = {
      start: editorState.start,
      end: editorState.end,
      anchorOffset: editorState.anchorOffset,
      focusOffset: editorState.focusOffset
    };
  }

  var _position = position,
      start = _position.start,
      end = _position.end;
  var isCollapsed = start === end;

  if (isUndo(event)) {
    newEditorState = change_1.undo(editorState);
  } else if (isMoveFocus(event)) {
    if (event.key === 'ArrowLeft' && event.metaKey) {} else if (event.key === 'ArrowLeft' && event.altKey) {} else if (event.key === 'ArrowLeft') {
      newEditorState = change_1.moveFocusBack(editorState);
    } else if (event.key === 'ArrowRight' && event.metaKey) {} else if (event.key === 'ArrowRight' && event.altKey) {} else if (event.key === 'ArrowRight') {
      newEditorState = change_1.moveFocusForward(editorState);
    }
  } else if (isSelectAll(event)) {
    newEditorState = change_1.updateSelection(editorState, {
      start: 0,
      end: editorState.list.value.length - 2,
      anchorOffset: 0,
      focusOffset: editorState.list.value.length - 2
    });
  } else if (isRedo(event)) {
    newEditorState = change_1.redo(editorState);
  }

  if (newEditorState == null && !inputEventSupported) {
    if (isCollapsed && event.key === 'Backspace' && event.metaKey === true) {
      newEditorState = change_1.backspaceToBlockStart(editorState, start, end);
    } else if (isCollapsed && event.key === 'Backspace' && event.altKey === true) {
      newEditorState = change_1.backspaceToPrevWord(editorState, start, end);
    } else if (event.key === 'Backspace' && isCollapsed) {
      newEditorState = change_1.backspace(editorState, start, end);
    } else if (event.key === 'Backspace' && !isCollapsed) {
      newEditorState = change_1.removeRange(editorState, start, end);
    } else if (event.key === 'Enter') {
      newEditorState = change_1.splitBlock(editorState, start, end);
    } else if (event.key === 'Delete' && isCollapsed) {
      newEditorState = change_1.deleteForward(editorState, start, end);
    } else if (event.key === 'Delete' && !isCollapsed) {
      newEditorState = change_1.removeRange(editorState, start, end);
    } else if (isCharacterInsert(event)) {
      newEditorState = change_1.insertCharacter(editorState, start, end, event.key);
    }
  }

  return newEditorState;
}

exports.default = handleKeyDown;